import React, { useEffect } from 'react';
import withAuth from '../../hocs/withAuth';
import { Row, Col, Container } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMyBusiness } from '../../store/actions/business';

import NavbarBusiness from '../Components/BusinessNavbar';
import BusinessSidebar from '../Components/BusinessSidebar';

import DashboardHeader from './Components/DashboardHeader';
import StatsCards from './Components/StatsCards';
import DealsPreview from './Components/DealsPreview';
import ProductsPreview from './Components/ProductsPreview';
import PostsPreview from './Components/PostsPreview';
import BuildingsPreview from './Components/BuildingsPreview';

import './index.css';

const DashboardPage = () => {
	const dispatch = useDispatch();

	const { id } = useSelector((state) => state.currentUser.user);
	const business = useSelector((state) => state.myBusiness);

	useEffect(() => {
		if (id) {
			dispatch(fetchMyBusiness(id));
		}
	}, [dispatch, id]);

	return (
		<div className='business-page-shell'>
			<NavbarBusiness />

			<Row className='g-0 no-gutters'>
				<Col xs='12' md='3' lg='3'>
					<BusinessSidebar />
				</Col>

				<Col xs='12' md='9' lg='9' className='business-page-shell__main'>
					<Container fluid className='dashboard-page'>
						<DashboardHeader business={business} />
						<StatsCards business={business} />

						<Row>
							<Col xl='8' lg='7' md='12'>
								<DealsPreview deals={business.groupDeals || []} />
							</Col>

							<Col xl='4' lg='5' md='12'>
								<BuildingsPreview buildings={business.buildings || []} />
							</Col>
						</Row>

						<Row>
							<Col lg='6' md='12'>
								<ProductsPreview products={business.products || []} />
							</Col>

							<Col lg='6' md='12'>
								<PostsPreview posts={business.newsFeeds || []} />
							</Col>
						</Row>
					</Container>
				</Col>
			</Row>
		</div>
	);
};

export default withAuth(DashboardPage);
